// extracted by mini-css-extract-plugin
export default {"menu_wrapper":"MenuOptions_menu_wrapper__MN9XS"};